import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CODESET_FEATURE_KEY, CodesetState } from './codeset.reducer';

const getCodesetState = createFeatureSelector<CodesetState>(
  CODESET_FEATURE_KEY,
);

const getCodeset = createSelector(
  getCodesetState,
  (state) => state.codeSetResponse,
);

export const codeSetQuery = {
  getCodeset,
};
